import axios from '../requester';
import { API } from '../constants/api-urls';

const defaultParams = { params: { add_license: true } };

export const getOrganization = async () =>
  axios.get(API.ORGANIZATIONS_PATH, defaultParams);
export const createOrganization = async data =>
  axios.post(API.ORGANIZATIONS_PATH, data, defaultParams);
